import Axios from "./caller.service";

// =====================================================================
// SERVICE : historique des demandes (Calibration / SAV / Support)
// =====================================================================
// Regroupe les appels API vers les endpoints d'historique et de
// re-telechargement des PDF archives cote backend.
// =====================================================================

// Configuration des 3 types de demandes (endpoint + libelle de type).
export const REQUEST_TYPES = {
  calibration: {
    key: "calibration",
    endpoint: "calibrationRequest",
  },
  sav: {
    key: "sav",
    endpoint: "savRequest",
  },
  support: {
    key: "support",
    endpoint: "supportRequest",
  },
};

/**
 * Recupere l'historique d'un type de demande pour un utilisateur.
 * @param {string} typeKey  "calibration" | "sav" | "support"
 * @param {number} ownerId
 * @returns {Promise<Array>} liste des demandes (avec champ `_type`).
 */
export const getRequestHistory = async (typeKey, ownerId) => {
  const cfg = REQUEST_TYPES[typeKey];
  if (!cfg) throw new Error(`Type de demande inconnu: ${typeKey}`);

  const res = await Axios.get(`/${cfg.endpoint}/history/${ownerId}`);
  const rows = res?.data?.data || [];
  // On tague chaque ligne avec son type pour l'affichage/filtre.
  return rows.map((r) => ({ ...r, _type: typeKey }));
};

/**
 * Recupere l'historique des 3 types en parallele, fusionne et trie
 * par date de creation decroissante.
 * @param {number} ownerId
 * @returns {Promise<Array>}
 */
export const getAllRequestHistory = async (ownerId) => {
  const results = await Promise.allSettled(
    Object.keys(REQUEST_TYPES).map((key) => getRequestHistory(key, ownerId))
  );

  const merged = results
    .filter((r) => r.status === "fulfilled")
    .flatMap((r) => r.value);

  return merged.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );
};

/**
 * Telecharge le PDF d'une demande et declenche l'enregistrement navigateur.
 * @param {string} typeKey
 * @param {number} ownerId
 * @param {number} requestId
 * @param {string} filename
 */
export const downloadRequestPdf = async (typeKey, ownerId, requestId, filename) => {
  const cfg = REQUEST_TYPES[typeKey];
  if (!cfg) throw new Error(`Type de demande inconnu: ${typeKey}`);

  const response = await Axios.get(
    `/${cfg.endpoint}/download/${ownerId}/${requestId}`,
    { responseType: "blob" }
  );

  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || `demande_${requestId}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
